import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'

import { useThreadsServiceGetV1IndividualsByIndividualIdThreads } from '../client/queries'
import { ThreadArray } from '../client/requests'

export type ThreadType = ThreadArray[number]

export const useThreads = (individualId?: string) => {
  const token = useFirebaseToken()

  return useThreadsServiceGetV1IndividualsByIndividualIdThreads(
    { individualId: individualId! },
    undefined,
    {
      enabled: !!individualId && !!token,
    },
  )
}
